module.exports = __webpack_public_path__ + "img/period-check.cea5fcb5.svg";